import { Currency, formatCLP, formatUF } from '../../../common/format';
import { BasePolicyRow } from '../types';

export interface ProjectionColumn<TRow = BasePolicyRow> {
  id: keyof TRow & string;
  label: string;
  isMoney: boolean;
}

export const COMMON_PROJECTION_COLUMNS: ProjectionColumn[] = [
  { id: 'year', label: 'Año', isMoney: false },
  { id: 'age', label: 'Edad', isMoney: false },
  { id: 'actuarial_age', label: 'Edad actuarial', isMoney: false },
  { id: 'agreed_deposits', label: 'Aportes acordados', isMoney: true },
  { id: 'accumulated_prime', label: 'Prima acumulada', isMoney: true },
  { id: 'coverage_costs', label: 'Costo coberturas', isMoney: true },
  { id: 'death_compensation', label: 'Indemn. fallecimiento', isMoney: true },
  { id: 'policy_expenses', label: 'Gastos póliza', isMoney: true },
  { id: 'policy_value', label: 'Valor póliza', isMoney: true },
  { id: 'withdrawable_amount', label: 'Monto rescatable', isMoney: true },
];

export function renderProjectionCell<TRow extends BasePolicyRow>(
  row: TRow,
  col: ProjectionColumn<TRow>,
  currency: Currency,
  ufValue: number,
): string {
  const raw = row[col.id];
  if (raw === undefined || raw === null) return '—';
  if (!col.isMoney) return String(raw);
  const num = Number(raw);
  const value = currency === 'CLP' ? num * ufValue : num;
  return currency === 'CLP' ? formatCLP(value) : formatUF(value);
}
